'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
var breakpoints = require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
var table = require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var caption = require('./caption.js');
var standardTbody = require('./standard-tbody.js');
var table$1 = require('./table.js');
var td = require('./td.js');
var tfoot = require('./tfoot.js');
var th = require('./th.js');
var thead = require('./thead.js');
var tr = require('./tr.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StandardTable = (props)=>{
    const { breakpoints: breakpoints$1 =[
        breakpoints.Breakpoints.Sm
    ] , caption: caption$1 , captionProps , colGroup , columns , empty , emptyContent , emptyTrProps , error , errorContent , errorTrProps , footer , footerContent , hover =true , id , loaderLabel ='' , loaderTrProps , loading , look =table.TableLooks.Default , maxHeight , rows , scrollX =true , scrollY , showCaption , tableProps , tbodyProps , tdProps , tfootProps , thProps , theadProps , trProps  } = props;
    const columnsLength = columns.length;
    const rowsLength = rows.length;
    const isEmpty = empty ?? rowsLength === 0;
    return /*#__PURE__*/ React__default.default.createElement(table$1.Table, _extends({}, tableProps, {
        breakpoints: breakpoints$1,
        empty: isEmpty,
        error: error,
        footer: footer,
        hover: hover,
        id: id,
        loading: loading,
        look: look,
        maxHeight: maxHeight,
        scrollX: scrollX,
        scrollY: scrollY
    }), /*#__PURE__*/ React__default.default.createElement(caption.Caption, _extends({}, captionProps, {
        breakpoints: breakpoints$1,
        showCaption: showCaption
    }), caption$1), colGroup && colGroup, /*#__PURE__*/ React__default.default.createElement(thead.THead, _extends({}, theadProps, {
        breakpoints: breakpoints$1
    }), /*#__PURE__*/ React__default.default.createElement(tr.Tr, _extends({}, trProps, {
        breakpoints: breakpoints$1,
        look: look
    }), columns.map((column, columnIndex)=>/*#__PURE__*/ React__default.default.createElement(th.Th, _extends({}, thProps, {
            breakpoints: breakpoints$1,
            key: `${id}-th-${columnIndex}`,
            centered: column.centered,
            scope: "col",
            style: {
                maxWidth: column.maxWidth,
                minWidth: column.minWidth,
                width: column.width
            },
            title: column.headingTitle
        }), column.children)))), /*#__PURE__*/ React__default.default.createElement(standardTbody.StandardTBody, _extends({}, tbodyProps, {
        breakpoints: breakpoints$1,
        columnsLength: columnsLength,
        empty: isEmpty,
        emptyContent: emptyContent,
        emptyTrProps: emptyTrProps,
        error: error,
        errorContent: errorContent,
        errorTrProps: errorTrProps,
        loaderLabel: loaderLabel,
        loaderTrProps: loaderTrProps,
        loading: loading
    }), rows.map((row, rowIndex)=>/*#__PURE__*/ React__default.default.createElement(tr.Tr, _extends({}, trProps, {
            breakpoints: breakpoints$1,
            key: `${id}-tr-${rowIndex}`,
            look: look
        }), columns.map((column, columnIndex)=>/*#__PURE__*/ React__default.default.createElement(td.Td, _extends({}, tdProps, {
                className: classnames__default.default({
                    [`${column.tdClassName}`]: !!column.tdClassName,
                    [`${tdProps?.className}`]: !!tdProps?.className
                }),
                key: `${id}-td-${columnIndex}`,
                breakpoints: breakpoints$1,
                centered: column.centered,
                ellipsis: column.ellipsis,
                heading: column.heading,
                style: {
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth,
                    width: column.width
                },
                title: column.cellTitle
            }), row[column.rowKey]))))), footer && footerContent && /*#__PURE__*/ React__default.default.createElement(tfoot.TFoot, _extends({}, tfootProps, {
        breakpoints: breakpoints$1
    }), /*#__PURE__*/ React__default.default.createElement(tr.Tr, _extends({}, trProps, {
        breakpoints: breakpoints$1,
        look: look
    }), /*#__PURE__*/ React__default.default.createElement(td.Td, _extends({}, tdProps, {
        breakpoints: breakpoints$1,
        colSpan: columnsLength
    }), footerContent))));
};

exports.StandardTable = StandardTable;
//# sourceMappingURL=standard-table.js.map
